import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import SpanishDatePicker from "@/components/SpanishDatePicker";

export default function PhysioBlockDialog({ open, onOpenChange, initial, onSaved }) {
  const [form, setForm] = useState({ date: "", start_time: "19:00", end_time: "21:00", reason: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setForm({
      date: initial?.date || "",
      start_time: initial?.start_time || "19:00",
      end_time: initial?.end_time || "21:00",
      reason: "",
    });
  }, [open, initial]);

  const save = async () => {
    if (!form.date) { toast.error("Selecciona una fecha"); return; }
    setSaving(true);
    try {
      await api.post("/physio/blocks", form);
      toast.success("Horario bloqueado");
      onSaved?.();
      onOpenChange(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo bloquear");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="physio-block-dialog">
        <DialogHeader>
          <DialogTitle>Bloquear horario</DialogTitle>
          <DialogDescription>Un horario bloqueado no admite reservas. No podrás bloquear una franja con una cita activa sin resolverla antes.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div><Label>Fecha *</Label><SpanishDatePicker value={form.date} onChange={(v) => setForm({ ...form, date: v })} testId="physio-block-date" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Desde</Label><Input type="time" value={form.start_time} onChange={(e) => setForm({ ...form, start_time: e.target.value })} data-testid="physio-block-start" /></div>
            <div><Label>Hasta</Label><Input type="time" value={form.end_time} onChange={(e) => setForm({ ...form, end_time: e.target.value })} data-testid="physio-block-end" /></div>
          </div>
          <div><Label>Motivo</Label><Input value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} placeholder="Ej. vacaciones, festivo, reunión" data-testid="physio-block-reason" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={save} disabled={saving} className="bg-slate-700 hover:bg-slate-800" data-testid="physio-block-save">
            {saving ? "Guardando…" : "Bloquear"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
